import { useState } from "react"
import { BasicButton } from "../../../theme/Component/BasicButton"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { BasicTable, MASK_NUMBER } from "../../../theme/Component/BasicTable"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { _DocumentFactory, _single } from "../../../../core/services/dataBean/EntityCatalog"
import { ImportXLSX } from "../../../theme/Component/ImportXLSX"

export const ImportAbstractAccount = () => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_DocumentFactory)


    const [data, setData] = useState<any>({})

    const importAbstracAccount = () => {
        instance.importAbstracAccount(_single.getAccountID(),JSON.stringify(data)).then(
            (resp:any)=>{
                setLista(resp); 
            }
        )
    }

    const head = [
        { title: 'Identificación', property: 'ID', visible: true,mask:MASK_NUMBER},        
        { title: 'Mensaje', property: 'Message', visible: true},
    ]

    return (
        <BasicPage titulo="Importar Terceros" >
            <div className="row">
                <div className="col-md-8">
                    <ImportXLSX lodaData={setData} />
                </div>
                <div className="col-md-4">
                    <BasicButton eventClick={importAbstracAccount} icon="ri-send-plane-line" useMargin children={`Importar`} />
                </div>
                <div className="col-md-12">
                    <a href="assets/extra/IMPORT_TERCERO.xlsx" target="_blank">Plantilla</a>
                </div>

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} />
                    {/* {JSON.stringify(data)} */}
                </div>
            </div>
        </BasicPage>
    )
}